import { render } from "./Graph.Cpu.Load.vue?vue&type=template&id=192cdfa4&scoped=true"
import script from "./Graph.Cpu.Load.vue?vue&type=script&lang=js"
export * from "./Graph.Cpu.Load.vue?vue&type=script&lang=js"

import "./Graph.Cpu.Load.vue?vue&type=style&index=0&id=192cdfa4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZELINK\\Wajiha\\Projects\\EzenmsV2_vueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192cdfa4"]])

export default __exports__